import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import CustomCard from "../../UI/CustomCard/CustomCard";
import InfoItems from "../../UI/InfoItems/InfoItems";
import RuleSetStatusBadge from "../../Presentational/DuplicatePerson/DuplicateStatusBadge";
const DuplicateReviewTab = ({ ruleSet }) => {
    const status = !!ruleSet.active;
    return (_jsx(_Fragment, { children: _jsx(CustomCard, { customHeader: _jsx("div", { className: "card-header title-block clearfix bg-white ", children: _jsxs("div", { className: "d-flex justify-content-between", children: [_jsx("h1", { className: "card-title", children: ruleSet.name }), _jsx("div", { className: "h5 mt-1", children: _jsx("span", { className: `badge badge-${status ? "success" : "secondary"} clearfix`, children: status ? "Active" : "Inactive" }) })] }) }), children: _jsx("div", { className: "card-body", children: _jsx(InfoItems, { numColumnsLg: 2, numColumnsMd: 2, items: [
                        {
                            label: "First Name",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.firstName }),
                        },
                        {
                            label: "Last Name",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.lastName }),
                        },
                        {
                            label: "Personal Email Address",
                            value: (_jsx(RuleSetStatusBadge, { status: ruleSet.personalEmailAddress })),
                        },
                        {
                            label: "Birthdate",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.birthDate }),
                        },
                        {
                            label: "Address Line 1",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.addressLine1 }),
                        },
                        {
                            label: "City",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.city }),
                        },
                        {
                            label: "State",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.state }),
                        },
                        {
                            label: "Zip Code",
                            value: _jsx(RuleSetStatusBadge, { status: ruleSet.zipCode }),
                        },
                    ] }) }) }) }));
};
export default DuplicateReviewTab;
